import { render, staticRenderFns } from "./Document-filter-type.vue?vue&type=template&id=57fce70d&scoped=true"
import script from "./Document-filter-type.vue?vue&type=script&lang=js"
export * from "./Document-filter-type.vue?vue&type=script&lang=js"
import style0 from "./Document-filter-type.vue?vue&type=style&index=0&id=57fce70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fce70d",
  null
  
)

export default component.exports